/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import FirstView from '../../asset/firstview.png';
import TheLayout from '../../layout/TheLayout';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import interviewImg1 from '../../asset/Interviews/Interview04/interview04_1.jpg';
import './interview_article.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Interview04 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const conversations = [
    {
      question: '今回TERRA　FORESTAの商品ご導入をされた切欠をお伺いできますか。',
      answer: '緊急事態宣言が出てコロナに対する不安がどんどん大きくなり導入をしました。',
    },
    {
      question: '貴社は法人営業が主だと思いますが、気をつけていることなどありますか。',
      answer: `弊社のお客様は、上場会社から個人事業主の方まで多様におり、そのなかで工場を運営されている法人様が多いです。<br />
      工場となりますと、多くの従業員の方々がいらっしゃいますので、一人でも感染者を出してしまうと工場の稼働がストップしてしまいます。<br />
      工場の稼働がストップしてしまっては困りますので、工場の事業主様は感染対策をしっかりされている方が非常に多いんです。<br />
      弊社は、感染対策をしっかりされている法人様に訪問等をするので、弊社スタッフも皆感染対策をしっかりし、お客様にご迷惑をおかけしてはいけないと思い、TERRAの除菌剤を導入しています。`,
    },
    {
      question: '主にどのような場所にご導入をしましたか。',
      answer: `私は、会社、そして自宅、道場、車内に導入しました。<br />
      実は、道場は光触媒のコーティングもTERRA様にお願いをしたんです。`,
    },
    {
      question: '道場というのは？',
      answer: `私は、平日夜・土日に4歳～小学6年生までのお子様にキックボクシング、空手道場を行っています。<br />
      道場は特に、子供とご両親の方が多くいらっしゃいます。<br />
      また、道場は素手が基本なので、特にコロナ感染者を出してはいけないと思い、道場の入口にTERRAのハンディスプレーを置き、且つ光触媒コーティングで徹底除菌をしました。<br />
      おかげで職場、道場ともに今までコロナ感染者は一人も出ていないという結果となっております。`,
    },
    {
      question: '職場とご自宅にもご導入されているということですが、どのような対策をされているのでしょうか。',
      answer: `TOWER型加湿器とハンディスプレーを職場と自宅の両方に導入しました。<br />
      自宅の方は、この度子供が生まれまして、やはり奥さんが妊婦の時から人体に影響のない除菌対策をと思い、自宅にも導入をしました。<br />
      TERRAの商品は、化学製品が一切使用されていないので、子供を育てる場でも安心して利用しています。`,
    },
    {
      question: 'TERRAの商品を多くご利用されていますが、ご導入されていかがですか。',
      answer: `定期便で月に1回届くので注文が楽なのと、僕自身は「ひのきの香」が気に入ってます。<br />
      ドラッグストアでも多くの除菌剤が販売されていますが、どれがいいのか正直わからないのと、個人的に科学的な香りが苦手なので、この「ひのきの香」は気にならない程度のちょうどいい香りだと思ってます。`,
    },
    {
      question: 'TERRAの商品をご愛用されているなか、今後TERRA様に期待されることはありますか。',
      answer: `やはりコロナは普通の病気ではないと個人的に思っており、今後も僕自身は継続して自分ができる除菌対策をしていく予定です。<br />
      おそらく多くの方が同じ気持ちかと思うのですが、TERRAの商品は良い商品なので、もっと国や多くの人たちに認知されるようになってほしいなと思ってます。<br />
      できたら、ドラッグストアとかにも置いて頂けると、利用者としては嬉しいです。<br />
      今後も継続して愛用させて頂きます。`,
    },
  ];

  const renderQnA = () => conversations.map((qna) => (
    <div className="row interview-qna" key={qna.question}>
      {
        qna.img
        && (
          <div className="col">
            <img src={qna.img} style={{ width: '100%' }} alt="" />
          </div>
        )
      }
      {
        qna.question
        && (
          <div className="col">
            <div className="interview-question">
              <span className="interview-question-dash" />
              {qna.question}
            </div>
            <div className="interview-answer" dangerouslySetInnerHTML={{ __html: qna.answer }} />
          </div>
        )
      }
    </div>
  ));

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>お客様の声｜株式会社TERRA</title>
      </Helmet>
      <div className="interview-introduction-detail">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          お客様の声
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>お客様の声</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-0">
          <div className="row m-0">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9 p-0">
              <div
                className="m-auto p-0 p-lg-5"
              >
                <div className="interview-post-container">
                  <h4 className="interview-post-title">
                    過去コロナ感染者0！
                    <br />
                    法人営業会社と空手道場を運営されているオーナー様のお声
                  </h4>
                  <div>
                    <img src={interviewImg1} style={{ width: '100%' }} alt="VivaceImg" />
                  </div>
                  <div>
                    <div className="interview-name">
                      TERRA商品をご愛用者様ご利用の声vol,4
                    </div>
                    <div className="interview-intro">
                      車の部品やレアリング、鉄等を加工する機械や建設業の方が鉄を切断する機械などを販売されている
                      <span>「有限会社中部キカイサービス」</span>
                      代表取締役 崎村様にご利用されている場所やご利用のきっかけなどをお伺い致しました。
                    </div>
                  </div>
                  <div className="interview-conversations">
                    {renderQnA(conversations)}
                  </div>
                  <div className="interview-end">
                    <p>インタビュー協力</p>
                    <p>有限会社中部キカイサービス</p>
                    <p>代表取締役　崎村　暁東様</p>
                    <a
                      className="interview-vivace-link"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.cmsmie.com/"
                      style={{ color: '#0000FF' }}
                    >
                      https://www.cmsmie.com/
                    </a>
                    <p>取材・文</p>
                    <p>ARIA株式会社　青山　綾子</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default Interview04;
